/**
 * Go back to IME Page when closing the register modal.
 */
export function goBackOnRegisterModal() {
	const $container = $( '.page-template-ime-confirmation .modal-registration' );
	if ( !$container.length ) {
		return;
	}

	const $closeButton = $container.find( '.o__modal-close-button' );

	$closeButton.on( 'click', function goBack() {
		$container.addClass( 'visuallyhidden' );
		window.history.back();
	});
}